const Footer = () => {
    console.log("fooder called")
    return (
        <>
            <div className="container-fluid" style={{
                position: '',
                bottom: '0',
                width: '100%',
                backgroundColor: 'gray',
                userSelect:'none'
            }}>
                <div className="row text-center p-2">
                    <div className="col">   
                        <h6 className="h6" style={{ color: 'snow' }}>
                            2024 57 Peace Protection Pte. Ltd. All rights reserved. Disclaimer Privacy Policy
                        </h6>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Footer;